
import {Component, Vue} from 'vue-property-decorator'
import {isAgreeConfirm, openNewPageFromPath} from "@/utils/h5ToApp";

@Component
export default class MessageProtect extends Vue {
    toPath(path: string) {
        openNewPageFromPath(path)
    }

    /**
     * 是否同意
     * @param type '0'不同意 '1'同意
     */
    isAgree(type: string){
        isAgreeConfirm({ type })
    }
}
